import { ChangeEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { getEngAdminAutocomplete } from "../../redux/actions/fluxoNSimilar";
import Input from "../fluxo-engenheiro/formBasic/Input";
import { ModalButtons } from "../ModalButtons/modalButtons";
import ContainerError from "../error/containerError";
import IconAlert from "../../assets/svgs/icon-alert.svg";
import "../fluxo-tax/smallModalEdit/smallModal.css";
import "./modalNovoGrupo.css";

interface UserAutocompleteOption {
  id: string;
  email: string;
}

interface ModalNovoParticipanteProps {
  groupName: string;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: (userId: string) => void;
}

const ModalNovoParticipante = ({
  groupName,
  isSubmitting,
  onClose,
  onConfirm,
}: ModalNovoParticipanteProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [participantSearch, setParticipantSearch] = useState("");
  const [participantOptions, setParticipantOptions] = useState<
    UserAutocompleteOption[]
  >([]);
  const [selectedParticipant, setSelectedParticipant] =
    useState<UserAutocompleteOption | null>(null);
  const [showParticipantDropdown, setShowParticipantDropdown] =
    useState(false);
  const [touched, setTouched] = useState(false);

  const handleParticipantChange = async (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    setParticipantSearch(value);
    setSelectedParticipant(null);

    if (value.length < 3) {
      setParticipantOptions([]);
      setShowParticipantDropdown(false);
      return;
    }

    try {
      const response = await dispatch(
        getEngAdminAutocomplete({ search: value }),
      ).unwrap();
      const options = response as UserAutocompleteOption[];

      setParticipantOptions(options);
      setShowParticipantDropdown(options.length > 0);
    } catch {
      setParticipantOptions([]);
      setShowParticipantDropdown(false);
    }
  };

  const handleSelectParticipant = (option: UserAutocompleteOption) => {
    setSelectedParticipant(option);
    setParticipantSearch(option.email);
    setShowParticipantDropdown(false);
  };

  return (
    <div className="smallModalCorporateSession groupModal" data-testid="new-participant-modal">
      <div className="smallModal">
        <div className="containerTitleSmallModal groupModalTitle">
          <h1 className="titleSmallModal">Adicionar Participante</h1>
          <span className="groupModalSubtitle">{groupName}</span>
        </div>

        <div className="containerDescription">
          <div className="inputRow">
            <span style={{ marginTop: 15 }}>Email do participante</span>
            <div style={{ position: "relative" }}>
              <Input
                label=""
                width="100%"
                placeholder="Buscar usuário por email..."
                value={participantSearch}
                onChange={handleParticipantChange}
                onBlur={() => setTouched(true)}
                data-testid="input-group-participant"
              />

              {showParticipantDropdown && participantOptions.length > 0 && (
                <div
                  className="dataResult aprovadorDropdown"
                  data-testid="participant-dropdown"
                >
                  {participantOptions.map((option) => (
                    <button
                      key={option.id}
                      type="button"
                      className="dataItem"
                      aria-label={`Selecionar participante ${option.email}`}
                      data-testid={`participant-option-${option.id}`}
                      onClick={() => handleSelectParticipant(option)}
                      onMouseDown={(event) => event.preventDefault()}
                    >
                      {option.email}
                    </button>
                  ))}
                </div>
              )}

              {touched && !selectedParticipant && (
                <ContainerError
                  id="group-participant-error"
                  label="Campo obrigatório."
                  icon={IconAlert}
                  widthError="100%"
                  backgroudError="#FFD9D9"
                  colorError="#000000"
                />
              )}
            </div>
          </div>

          <ModalButtons
            buttonOne="Adicionar"
            buttonTwo="Cancelar"
            onConfirm={() => selectedParticipant && onConfirm(selectedParticipant.id)}
            onClose={onClose}
            isButtonDisabled={!selectedParticipant}
            isSubmitting={isSubmitting}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalNovoParticipante;